<template>
    <a
        href="#"
        @click="onShowModal($event)"
        v-bind="$attrs"
    >
        Which Fabric Should I Choose?
    </a>
    <ResponsiveModal
        v-model="dialog"
        width="60%"
        mobile-width="80%"
    >
        <template #default="{ onExit }">
            <v-card
                class="in-modal fill-width fill-height"
                flat
            >
                <v-card-title class="d-block pa-0">
                    <v-toolbar color="secondary" density="compact" flat>
                        <v-toolbar-title class="text-title-large">Fabric Guide</v-toolbar-title>
                        <v-btn
                            @click="onExit"
                            :icon="mdiWindowClose"
                        >
                        </v-btn>
                    </v-toolbar>
                </v-card-title>
                <v-card-text class="px-4 pb-0">
                    <v-container>
                        <v-table>
                            <colgroup>
                                <col width="25%" />
                                <col width="40%" />
                                <col width="25%" />
                                <col width="10%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Fabric</th>
                                    <th>Function</th>
                                    <th>Materials</th>
                                    <th>Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in data">
                                    <td class="text-center">
                                        <h4
                                            class="py-0 my-0"
                                        >
                                            {{ item.fabric.title }}
                                        </h4>
                                        <small
                                            class="text-title-small"
                                        >
                                            {{ item.fabric.subtitle }}
                                        </small>
                                    </td>
                                    <td>
                                        <p>{{ item.function.content }}</p>
                                    </td>
                                    <td>
                                        <ul class="ma-0 pa-0">
                                            <li
                                                v-for="material in item.materials.items"
                                            >
                                                {{ material }}
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <span class="text-no-wrap">
                                            {{ item.weight.amount }} <small>{{ item.weight.unit }}</small>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="4" class="text-center">
                                        <p class="text-size-fine">
                                            GSM (grams per square meter)<br />
                                            150-200 GSM ≈ T-shirt fabric<br />
                                            250-350 GSM ≈ Sweatshirt / Jacket fabric
                                        </p>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-table>
                    </v-container>
                </v-card-text>
            </v-card>
        </template>
    </ResponsiveModal>
</template>

<script lang="ts" setup>
    import { mdiWindowClose } from '@mdi/js';

    const dialog = ref(false);

    const data = [
        {
            fabric: {
                title: 'Cotna 155',
                subtitle: 'Smooth and Insulating'
            },
            function: {
                content: 'Insulating base layer for moderate activity and cooler conditions.'
            },
            materials: {
                items: [
                    '90% Cotna',
                    '5% Elastane'
                ]
            },
            weight: {
                amount: 155,
                unit: 'GSM'
            }
        },
        {
            fabric: {
                title: 'Polyester / Tencel 155',
                subtitle: 'Light and Breathable'
            },
            function: {
                content: 'Thin and moisture-wicking for heavy activity and warmer conditions.'
            },
            materials: {
                items: [
                    '85% Polyester',
                    '11% Tencel',
                    '4% Elastane'
                ]
            },
            weight: {
                amount: 155,
                unit: 'GSM'
            }
        },
        {
            fabric: {
                title: 'Pima Cotton 155',
                subtitle: 'Soft and Comfortable'
            },
            function: {
                content: 'Super-soft, light and breathable for ultimate comfort.'
            },
            materials: {
                items: [
                    '95% Pima Cotton',
                    '5% Elastane'
                ]
            },
            weight: {
                amount: 155,
                unit: 'GSM'
            }
        },
        {
            fabric: {
                title: 'Pima Cotton 180',
                subtitle: 'Soft and Sturdy'
            },
            function: {
                content: 'Soft, medium weight for versatile comfort.'
            },
            materials: {
                items: [
                    '96% Pima Cotton',
                    '4% Elastane'
                ]
            },
            weight: {
                amount: 180,
                unit: 'GSM'
            }
        },
        {
            fabric: {
                title: 'Pima Cotton / Polyester 320',
                subtitle: 'Warm and Breathable'
            },
            function: {
                content: 'Soft and sturdy French Terry style for comfort and cooler conditions.'
            },
            materials: {
                items: [
                    '58% Pima Cotton',
                    '37% Polyester',
                    '5% Elastane'
                ]
            },
            weight: {
                amount: 320,
                unit: 'GSM'
            }
        },
    ];

    function onShowModal(e: Event) {
        e.preventDefault();
        dialog.value = true;
    }
</script>

<style lang="scss" scoped></style>
